import React, { useEffect, useState } from 'react';

//Material
import { Box, Paper, Rating, Typography } from '@mui/material';

// import { Stack } from '@mui/system';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import basePhoto from '../assets/DefaultIMG.png';
import '../pages/MainPage/index.css';
import { IncrementBtn } from './Buttons';

// import  ImageGallery  from 'react-image-gallery';

// const useStyles = makeStyles({

//   button: {
//     '&:hover': {
//       boxShadow: '-5px 5px 3px black !important',
// width: '155px !important'
//   },
// }})
function ServiceCardOrder({ el, setter, qty, ...props }) {
  // const apiPhoto = new ApiService('photo/get-photo');
  // const apiPhoto = new ApiService('get-photo');
  const [photos, setPhotos] = useState([]);
  // const [isLoadingPhotos, setIsLoadingPhotos] = useState(false);
  // const classes = useStyles()
  // eslint-disable-next-line
  const userData = useSelector((state) => state.global.userData);
  // eslint-disable-next-line
  const language = useSelector((state) => state.Intl.locale);
  // eslint-disable-next-line
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;

    if (el?.photoUrls && el?.photoUrls.length !== 0 && mounted) {
      setPhotos([...el?.photoUrls]);
    }

    // eslint-disable-next-line
  }, []);
  return (
    <Paper
      {...props}
      // className="serviceCard"
      sx={{
        width: '100%',
        textAlign: 'center',
        overflow: 'hidden',
        alignItems: 'center',
        backgroundColor: 'white',
        border: 'none',

        boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
        borderRadius: '8px',
        p: { xs: '8px', sm: '24px' }
      }}
    >
      <Typography
        sx={{
          fontSize: 20,
          fontFamily: 'FixelText-Medium',
          mb: 2,
          textAlign: 'left',
          fontWeight: '500',
          color: '#1b1b1b'
        }}
      >
        Ваше замовлення:
      </Typography>
      <Box
        sx={{
          padding: '0px 0px 24px',
          borderBottom: '2px solid rgba(0, 0, 0, 0.05)',
          marginBottom: '24px',
          display: 'flex'
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', mr: '24px' }}>
          {' '}
          {el !== null &&
          el &&
          el?.photoUrls &&
          el?.photoUrls.length !== 0 &&
          el?.photoUrls.length >= 1 &&
          photos.length !== 0
            ? photos.map(
                (photo, index) =>
                  index === 0 && (
                    <img
                      key={`photo${index}`}
                      src={photo}
                      alt="serviceIllustration"
                      style={{
                        objectFit: 'contain',
                        maxHeight: '100px',
                        minHeight: '100px',
                        border: 'none',
                        borderRadius: '8px'
                      }}
                    />
                  )
              )
            : null}
          {/* {isLoadingPhotos&&<Skeleton sx={{ height: 84, width:84, border: '1px solid #60A5DF',
                borderRadius: '2.5px' }
                
                } animation="wave" variant="rectangular" />} */}
          {(el !== null && !el?.photoUrls) ||
          (el !== null && el?.photoUrls && el?.photoUrls.length === 0) ? (
            <img
              src={basePhoto}
              alt="defaultImg"
              style={{
                objectFit: 'contain',
                maxHeight: '84px',
                minHeight: '84px',
                border: '1px solid #60A5DF',
                borderRadius: '2.5px'
              }}
            />
          ) : null}
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center'
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: 16, sm: 20 },
              wordBreak: 'break-word',
              fontFamily: 'FixelText-Medium',
              fontWeight: '500'
            }}
          >
            {el.nameService}
          </Typography>
          <Typography variant="subtitle" sx={{ fontSize: 16, color: '#7C7C7C', fontWeight: '500' }}>
            {`Продавець: @${el.userDTO?.nickname}`}
          </Typography>
          <Typography
            sx={{
              fontSize: 16,
              fontWeight: '500',
              fontFamily: 'FixelText-Medium',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            {`${(+el.price).toFixed(2)} ${el.currency}`}
            <Rating
              value={el?.rating}
              precision={0.5}
              readOnly
              sx={{ fontSize: '18px', ml: '8px' }}
            />
          </Typography>
          {/*<Typography variant="subtitle" sx={{ fontSize: 14, color: '#B1B1B1', mt: 2 }}>*/}
          {/*    {`${el.valueOfInitOfMeasure} ${el.initOfMeasure}`}*/}
          {/*</Typography>*/}
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <Typography
          variant="subtitle"
          sx={{
            fontSize: { xs: 16, sm: 20 },
            color: '#7C7C7C',
            fontWeight: '500',
            display: 'flex',
            justifyContent: 'space-between',
            lineHeight: { xs: '26px', sm: '32px' },
            mb: '10px'
          }}
        >
          Орієнтовний час збору замовлення:
          <Typography
            sx={{
              fontSize: { xs: 16, sm: 20 },
              wordBreak: 'break-word',
              fontFamily: 'FixelText-Medium',
              fontWeight: '500',
              color: '#1b1b1b',
              lineHeight: { xs: '26px', sm: '32px' }
            }}
          >
            {`${el?.estimatedTime && el?.estimatedTime} дні`}
          </Typography>
        </Typography>

        <Typography
          variant="subtitle"
          sx={{
            fontSize: { xs: 16, sm: 20 },
            color: '#7C7C7C',
            fontWeight: '500',
            display: 'flex',
            justifyContent: 'space-between',
            lineHeight: { xs: '26px', sm: '32px' },
            mb: '10px'
          }}
        >
          Відправка здійснюється:
          <Typography
            sx={{
              fontSize: { xs: 16, sm: 20 },
              wordBreak: 'break-word',
              fontFamily: 'FixelText-Medium',
              fontWeight: '500',
              color: '#1b1b1b',
              lineHeight: { xs: '26px', sm: '32px' }
            }}
          >
            {el?.deliveryDays && el?.deliveryDays.length !== 0 && (
              <>
                {`${
                  el?.deliveryDays &&
                  el?.deliveryDays.length !== 0 &&
                  el?.deliveryDays.includes('Понеділок') &&
                  el?.deliveryDays.includes('Вівторок') &&
                  el?.deliveryDays.includes('Середа') &&
                  el?.deliveryDays.includes('Четвер') &&
                  el?.deliveryDays.includes("П'ятниця") &&
                  el?.deliveryDays.includes('Субота') &&
                  el?.deliveryDays.includes('Неділя')
                    ? 'Щодня'
                    : el?.deliveryDays.map((day, index) => {
                        switch (day) {
                          case 'Понеділок':
                            return ' Пн';
                          case 'Вівторок':
                            return ' Вт';
                          case 'Середа':
                            return ' Ср';
                          case 'Четвер':
                            return ' Чт';
                          case "П'ятниця":
                            return ' Пт';
                          case 'Субота':
                            return ' Сб';
                          case 'Неділя':
                            return ' Нд';
                          default:
                            return null;
                        }
                      })
                }`}
              </>
            )}
          </Typography>
        </Typography>
        <Typography
          variant="subtitle"
          sx={{
            fontSize: { xs: 16, sm: 20 },
            color: '#7C7C7C',
            fontWeight: '500',
            display: 'flex',
            justifyContent: 'space-between',
            lineHeight: { xs: '26px', sm: '32px' },
            mb: '10px'
          }}
        >
          Одиниці виміру товару:
          <Typography
            sx={{
              fontSize: { xs: 16, sm: 20 },
              wordBreak: 'break-word',
              fontFamily: 'FixelText-Medium',
              fontWeight: '500',
              color: '#1b1b1b',
              lineHeight: { xs: '26px', sm: '32px' }
            }}
          >
            {el?.initOfMeasure}.
          </Typography>
        </Typography>
        <Typography
          variant="subtitle"
          sx={{
            fontSize: { xs: 16, sm: 20 },
            color: '#7C7C7C',
            fontWeight: '500',
            display: 'flex',
            justifyContent: 'space-between',
            lineHeight: { xs: '26px', sm: '32px' },
            mb: '10px'
          }}
        >
          Ціна товару:
          <Typography
            sx={{
              fontSize: { xs: 16, sm: 20 },
              fontFamily: 'FixelText-Medium',
              fontWeight: '500',
              color: '#1b1b1b',
              lineHeight: { xs: '26px', sm: '32px' }
            }}
          >
            {`${(+el.price).toFixed(2)} ${el.currency} `}/
            {/*{`${(+el.price * qty).toFixed(2)} ${el.currency} `}/*/}
            <Typography
              variant="subtitle"
              sx={{
                fontSize: { xs: 16, sm: 20 },
                color: '#7C7C7C',
                fontWeight: '500',
                fontFamily: 'FixelText-Medium !important',
                lineHeight: { xs: '26px', sm: '32px' }
              }}
            >{` ${el?.valueOfInitOfMeasure} ${el?.initOfMeasure}`}</Typography>
          </Typography>
        </Typography>
        <Typography
          variant="subtitle"
          sx={{
            fontSize: { xs: 16, sm: 20 },
            color: '#7C7C7C',
            fontWeight: '500',
            display: 'flex',
            justifyContent: 'space-between',
            lineHeight: { xs: '26px', sm: '32px' },
            mb: '24px',
            borderBottom: '2px solid rgba(0, 0, 0, 0.05)',
            pb: '24px',
            alignItems: 'center'
          }}
        >
          Оберіть кількість:
          <IncrementBtn
            setter={(value) => setter(value)}
            value={qty}
            colorOfQty={+qty > +el?.availableQuantity ? 'red' : 'black'}
            // initOfMeasure={el.initOfMeasure}
            // disableIncrement={+el.valueOfInitOfMeasure === qty}
            disableDecrement={qty === 1}
          />
        </Typography>
        <Typography
          variant="subtitle"
          sx={{
            fontSize: { xs: 16, sm: 20 },
            color: '#7C7C7C',
            fontWeight: '500',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            lineHeight: { xs: '26px', sm: '32px' },
            mb: '10px'
          }}
        >
          До сплати:
          <Typography
            sx={{
              fontSize: { xs: 16, sm: 20 },
              fontFamily: 'FixelText-Medium',
              fontWeight: '500',
              color: '#1b1b1b',
              alignItems: 'center',
              lineHeight: { xs: '26px', sm: '32px' }
            }}
          >
            {`${(+el.price * qty).toFixed(2)} ${el.currency} `}/
            <Typography
              variant="subtitle"
              sx={{
                fontSize: { xs: 16, sm: 20 },
                color: '#7C7C7C',
                fontWeight: '500',
                fontFamily: 'FixelText-Medium !important',
                lineHeight: { xs: '26px', sm: '32px' }
              }}
            >{` ${el?.valueOfInitOfMeasure * qty} ${el?.initOfMeasure}`}</Typography>
          </Typography>
        </Typography>
      </Box>
    </Paper>
  );
}

// const mapStateToProps = (state) => {
//   return {
//     language: state.Intl.locale
//   };
// };
export default ServiceCardOrder;
